<div mat-dialog-content>
  <mat-form-field appearance="fill" style="width:95%">
    <mat-label>Tags</mat-label>
    <mat-select multiple [formControl]="tagsControl"  (selectionChange)="tagSelectionChange($event)">
      @for (group of tagGroups; track group) {
        <mat-optgroup [label]="group.name">
          @for (tag of group.tags; track tag) {
            <mat-option [value]="tag._key">
              {{tag.name}}
            </mat-option>
          }
        </mat-optgroup>
      }
    </mat-select>
  </mat-form-field>
  @for (group of getNodeGroupTypeList(); track group) {
    <mat-form-field appearance="fill" style="width:95%">
      <mat-label>{{group.toString()}}</mat-label>
      <mat-select multiple [formControl]="getNodeGroup(group).control" (selectionChange)="nodeSelectionChange($event)">
        @for (node of getNodeGroup(group).nodes; track node) {
          <mat-option [value]="node">
            {{node.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="clearFilter()">Clear filter</button>
  <button mat-raised-button (click)="applyFilter()">Apply filter</button>
  <button mat-raised-button (click)="cancel()">Cancel</button>
</div>

